export default __webpack_public_path__ + "static/mockupphone-093f7b90a9ac755c6ae7be466f740e89.svg";